import { createAsyncThunk } from '@reduxjs/toolkit';
import { TApplicationState } from '../../types/redux';
import { fetchFlatData } from './fetchFlatData';
import { IApplicationContext } from '../../types/applicationContext';
import { selectFlatFormValues } from '../../selectors/filters';
import { validateFilters } from '@cian/valuation-main-filters-widget';

export const submitFlatData = createAsyncThunk('form/submitFlatData', async (_, _thunkApi) => {
  const { extra, rejectWithValue, getState, dispatch } = _thunkApi;

  const isFormValid = await dispatch(validateFilters());

  if (!isFormValid) {
    return;
  }

  const { houseId, area, roomsCount, flatNumber } = selectFlatFormValues(getState() as TApplicationState);

  if (!houseId || !area || !roomsCount) {
    return;
  }

  const parameters = {
    houseId,
    area,
    roomsCount,
    flatNumber,
    isNeedPushSubscribe: false,
  };

  try {
    const res = await fetchFlatData(parameters, extra as IApplicationContext);

    return res;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});
